var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29354 2.38367C6.55471 2.34505 6.82414 2.32434 7.10164 2.32434C10.3823 2.32434 12.5351 5.21933 13.2583 6.3645C13.3458 6.5031 13.3896 6.57241 13.4141 6.6793C13.4325 6.75957 13.4325 6.88622 13.4141 6.9665C13.3896 7.07338 13.3455 7.14314 13.2573 7.28267C13.0646 7.58765 12.7708 8.01626 12.3816 8.48112M3.71101 3.42649C2.32158 4.36903 1.37831 5.67852 0.945597 6.36351C0.857671 6.5027 0.813708 6.57229 0.7892 6.67917C0.770794 6.75945 0.770786 6.88608 0.789184 6.96636C0.813679 7.07324 0.857444 7.14254 0.944973 7.28113C1.6682 8.4263 3.82096 11.3213 7.10164 11.3213C8.42445 11.3213 9.56389 10.8506 10.5002 10.2138M1.31788 1.03906L12.8854 12.6066M5.73839 5.45957C5.38951 5.80846 5.17372 6.29044 5.17372 6.82282C5.17372 7.88758 6.03688 8.75073 7.10164 8.75073C7.63402 8.75073 8.116 8.53495 8.46488 8.18606",
    stroke: "#373737",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeHide);
export default __webpack_public_path__ + "static/media/password-eye-hide.82a41d97b532ca6bcba851ed78c4c499.svg";
export { ForwardRef as ReactComponent };